import http from '../config/http';

const basicUrl = '/api/v1/dictionary-content';

const getDictionaryByType = (type: string) => {
    return http.get(basicUrl, { params: { type: type } });
};

const dictionaryContentService = {
    getDictionaryByType,
};

export default dictionaryContentService;
